<template>
    <div class="bg-white px-3 index" :style="{height:height}">
        <div class="header_cons_b">
            <div class="je_b">
                <div class="l">
                    <div class="l_n">{{moneydatas.kt_price?moneydatas.kt_price:0}}</div>
                    <div>可提现金额</div>
                </div>
                <div class="l r_bgc">
                    <div class="l_n">{{moneydatas.commission?moneydatas.commission:0}}</div>
                    <div>待入帐金额</div>
                </div>
            </div>
            <el-form class="form-inlines tx_b" label-width="100px" :model="formData" ref="formData">
                <el-form-item label="提现银行名称:">
                    <el-select v-model="formData.bank" placeholder="请选择提现银行" size="small" filterable
                        @change="selectbank">
                        <el-option v-for="item in bank_options" :key="item.id" :label="item.bank" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="提现银行卡号:">
                    <el-input v-model="formData.bank_card" size="small" style="width:200px" placeholder="请输入银行卡号">
                    </el-input>
                </el-form-item>
                <el-form-item label="提现金额:">
                    <el-input v-model="formData.money" size="small" type="number" min="1" style="width:200px"
                        placeholder="请输入提现金额"></el-input>
                </el-form-item>
                <div class="txbtn_b">
                    <el-button type="warning" class="txbtn" size="small" :loading='txloading' @click="txsubmit">提交审核
                    </el-button>
                </div>
                <!-- <el-form-item>
                    <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
                    </el-button>
                </el-form-item> -->
            </el-form>
        </div>
        <div class="add_tits" ref="title">
            <span class="txjl_s">
                提现记录
            </span>
            <el-form class="form-inlines " :inline="true">

                <el-form-item label="日期:">
                    <el-date-picker v-model="formData.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" size='small' value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="begin">查询</el-button>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
                    </el-button>
                </el-form-item> -->
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="create_time" label="提现时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{date('Y-m-d H:i:s', scope.row.create_time) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="提现金额" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="banks.bank" label="提现银行名称" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="banks.bank_card" label="提现银行卡号" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="pay_price" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{({1:'待处理',2:'已处理'})[scope.row.state]}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <!-- 导出 -->
        <el-dialog title="导出数据" :visible.sync="exportModal" center width="30%">
            <el-form :model="exportForm" ref="ruleForm">
                <el-form-item label="时间范围" required>
                    <el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportModal = false">取 消</el-button>
                <el-button type="primary" :loading='exporloading' @click="exportExcel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    bank_card: '',
                    bank: '',
                    money: '',

                },
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                dialogVisible: false,
                date: xaoi.date,
                exportModal: false,
                exportForm: {
                    time: []
                },
                exporloading: false,
                bank_options: [],
                bankdata: '',
                txloading: false,
                moneydatas: '',
                height: null,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getbank()
            this.getmoneys()
            that.getHeight()
            that.getDate6()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 280 + 'px'
                that.height = window.innerHeight - 150 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 280 + 'px'
                    that.height = window.innerHeight - 150 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            getmoneys() {
                this.axios.post('/admin/pc/CapitalDetails/prices', {}, {
                    token: true
                }).then(res => {
                    this.moneydatas = res.data.data
                })
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/tools/pretax/withdrawal_list", {
                        page: that.currentPage,
                        limit: that.pagesize,
                        start_time: this.formData.time ? this.formData.time[0] : '',
                        end_time: this.formData.time ? this.formData.time[1] : '',
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.data
                        that.tableData.forEach(ele => {
                            ele.banks = JSON.parse(ele.bank)
                        })
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            getbank() {
                let that = this
                axios
                    .post("/admin/pc/bank/myBankCard", {}, {
                        token: true
                    })
                    .then(response => {
                        that.bank_options = response.data.data
                    })
                    .catch(error => {})
            },
            selectbank(v) {
                this.bank_options.forEach(e => {
                    if (e.id == v) {
                        this.formData.bank_card = e.bank_card
                        this.bankdata = e
                    }
                })
            },
            //本月
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                this.formData.time = [start, end]
                that.begin()
            },
            openExportExcel() {
                this.exportModal = true
            },
            exportExcel() {
                if (this.exportForm.time.length == 0) return this.$message.error('请选择时间范围')
                let val = this.exportForm.time
                let params = ''
                if (val && Array.isArray(val)) {
                    params += `starttime=${val[0]}`
                    params += `&endtime=${val[1]}`
                }
                let url = `/admin/pc/Excel/docZjmx2Excel?`

                this.exporloading = true
                this.axios.post(url + params, {}, {
                    token: true,
                    responseType: 'blob'
                }).then(res => {
                    if (res.status == 200) {
                        this.exportModal = false
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        let filename = new Date().getTime() + '.xlsx';
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    } else if (res.data.code != 200) {
                        this.$message('暂无数据')
                    }
                    this.exporloading = false

                }).catch(err => {
                    this.exporloading = false

                })
            },
            txsubmit() {
                if (!this.formData.bank) return this.$message.error('请选择提现银行卡')
                if (!this.formData.bank_card) return this.$message.error('请输入提现银行卡号')
                if (this.formData.money == '') return this.$message.error('请输入提现金额')
                if (this.formData.money < 1) return this.$message.error('提现金额最小必须大于1')
                if ((this.moneydatas.kt_price - 0) < (this.formData.money - 0)) return this.$message.error('可提现金额不足！')
                this.txloading = true
                this.axios.post('/admin/pc/tools/pretax/withdrawal', {
                    amount: this.formData.money,
                    bank: JSON.stringify(this.bankdata)
                }, {
                    token: true
                }).then(res => {
                    this.txloading = false
                    if (res.data.code == 200) {
                        this.getmoneys()
                        this.$alert('提现审核提交成功, 等待管理员审核', '确定', {
                            confirmButtonText: '确定',
                            type: 'success',
                            center: true,
                            showCancelButton: false,
                            confirmButtonClass: 'warnbtn',
                            callback: action => {}
                        })
                    } else {
                        this.$message.error(res.data.msg)
                    }
                }).catch(err => {

                })


            }



        },

    };
</script>


<style lang="scss" scoped>
    .index {
        border-radius: 6px;
        overflow: auto;

        .header_cons_b {
            padding: 20px 0 10px;

            .je_b {
                display: flex;
                align-items: center;

                .l {
                    text-align: center;
                    width: 300px;
                    padding: 10px 0;
                    border-radius: 5px;
                    background-color: #5473E7;
                    color: #fff;
                    font-size: 16px;

                    .l_n {
                        margin-bottom: 5px;
                    }
                }

                .r_bgc {
                    background-color: #23BBC9 !important;
                    margin-left: 50px;
                }
            }

            .tx_b {
                margin: 10px 0;

                .txbtn_b {
                    margin-top: 10px;

                    .txbtn {
                        padding: 9px 35px;
                    }
                }

            }
        }

        .txjl_s {
            font-size: 16px;
            color: #252631;
            font-weight: 600;
        }

    }
</style>